import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MergeDuplicatesEmployee } from '@core/models/leave-admin/employees/merge-duplicates-data.model';
import { getInitials } from '@shared/helpers';

@Component({
    selector: 'app-merge-duplicates-card',
    templateUrl: './merge-duplicates-card.component.html',
    styleUrls: ['./merge-duplicates-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MergeDuplicatesCardComponent implements OnInit {
  static readonly componentName = 'MergeDuplicatesCardComponent';
  
  @Input() employeeInfo: MergeDuplicatesEmployee;
  @Input() sysText: any;
  @Input() isPrimary: boolean = false;

  public getInitials = getInitials;

  constructor() { }

  ngOnInit(): void {
  }

}
